// enums
export var InputState;
(function (InputState) {
    InputState["EMPTY"] = "EMPTY";
    InputState["ACTIVE"] = "ACTIVE";
    InputState["FILLED"] = "FILLED";
    InputState["ERROR_EMPTY"] = "ERROR_EMPTY";
    InputState["ERROR_FILLED"] = "ERROR_FILLED";
    InputState["ERROR_FILLED_WITH_INFO"] = "ERROR_FILLED_WITH_INFO";
    InputState["ERROR_ACTIVE"] = "ERROR_ACTIVE";
    InputState["DISABLED_FILLED"] = "DISABLED_FILLED";
    InputState["DISABLED_EMPTY"] = "DISABLED_EMPTY";
    InputState["DISABLED_FILLED_WITH_INFO"] = "DISABLED_FILLED_WITH_INFO";
})(InputState || (InputState = {}));
export var LABEL_TYPE;
(function (LABEL_TYPE) {
    LABEL_TYPE["STANDARD"] = "STANDARD";
    LABEL_TYPE["OUTLINED"] = "OUTLINED";
    LABEL_TYPE["FILLED"] = "FILLED";
})(LABEL_TYPE || (LABEL_TYPE = {}));
export var InputHelpMessagePosition;
(function (InputHelpMessagePosition) {
    InputHelpMessagePosition["TOP"] = "TOP";
    InputHelpMessagePosition["BOTTOM"] = "BOTTOM";
})(InputHelpMessagePosition || (InputHelpMessagePosition = {}));
export var InputIconPosition;
(function (InputIconPosition) {
    InputIconPosition["RIGHT"] = "RIGHT";
    InputIconPosition["LEFT"] = "LEFT";
})(InputIconPosition || (InputIconPosition = {}));
export var InputContentPosition;
(function (InputContentPosition) {
    InputContentPosition["INNER"] = "INNER";
    InputContentPosition["OUT"] = "OUT";
})(InputContentPosition || (InputContentPosition = {}));
//# sourceMappingURL=inputTheme.js.map